<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>{{ $t('addDomiciliationBancaire.domBancaireReglement.title') }}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="level">
            <div class="level-left">
              <selecteur-action
                @handleAction="handleAction"
                :elementsSelectionnes="domBancaireReglementList.some(d => d.selected)"
                :titleButton="'general.button.apply'"
                :options='actions'
                :placeholder='$t("general.placeHolder.groupedAction")'
              ></selecteur-action>
            </div>
            <div class="level-right columns">
              <div class="column is-narrow">
                <button class="button is-addOrEdit"
                        @click="openPopUpCreateSpecialisation = true">
                  {{ $t(
                  'addDomiciliationBancaire.domBancaireReglement.actions.specialiserModeReglement'
                ) }}
                </button>
              </div>
            </div>
          </div>
          <v-client-table :data="domBancaireReglementList"
                          :columns="columns"
                          :options="options"
                          ref='tableDomBancaireReglement'>
            <div slot="selected" slot-scope="props" class="has-text-centered">
              <b-checkbox v-model="domBancaireReglementList[props.index - 1].selected">
              </b-checkbox>
            </div>
            <div slot="modeReglement" slot-scope="props">
              {{ getModeReglement(props.row.modeReglementId) }}
            </div>
            <div slot="sens" slot-scope="props">
              {{ props.row.sens === constantes.SENS_VENTE ?
              $t('general.sens.vente') :$t('general.sens.achat') }}
            </div>
            <div slot="libelleEcriture" slot-scope="props">
              <b-input :value="props.row.libelleEcriture"
                       @focus="editLibelle(props.index - 1, props.row.sens, 'ecriture',
                       props.row.libelleEcriture, 'libelleEcriture', false)">
              </b-input>
            </div>
            <div slot="libelleLigneEcritureTiers" slot-scope="props">
              <b-input :value="props.row.libelleLigneEcritureTiers"
                       @focus="editLibelle(props.index - 1,
                       props.row.sens, 'ecritureTiers',
                       props.row.libelleLigneEcritureTiers,
                       'libelleLigneEcritureTiers',
                       false)">
              </b-input>
            </div>
            <div slot="libelleLigneEcritureBanque" slot-scope="props">
              <b-input :value="props.row.libelleLigneEcritureBanque"
                       @focus="editLibelle(props.index - 1,
                       props.row.sens, 'ecritureBanque',
                       props.row.libelleLigneEcritureBanque,
                       'libelleLigneEcritureBanque', false)">
              </b-input>
            </div>
            <div slot="libelleReferenceTiers" slot-scope="props">
              <b-input :value="props.row.libelleReferenceTiers"
                       @focus="editLibelle(props.index - 1,
                       props.row.sens, 'referenceTiers',
                       props.row.libelleReferenceTiers,
                       'libelleReferenceTiers', true)">
              </b-input>
            </div>
            <div slot="libelleReferenceBanque" slot-scope="props">
              <b-input :value="props.row.libelleReferenceBanque"
                       @focus="editLibelle(props.index - 1,
                       props.row.sens, 'referenceBanque',
                       props.row.libelleReferenceBanque,
                       'libelleReferenceBanque', true)">
              </b-input>
            </div>
            <div slot="actions" slot-scope="props">
              <b-dropdown position="is-bottom-left" aria-role="list">
                <a slot="trigger">
                  <b-icon class="is-flex" custom-class="has-text-icon-more" icon="dots-vertical"/>
                </a>
                <b-dropdown-item
                  @click="checkPermissions(constantes.DOMICILIATIONS_BANCAIRES.supprimer)
                    ? openPopUpPreventionToDelete(props.index - 1) : showPopUp()"
                  :class="{ 'text-access-no-permission' :
                    !checkPermissions(constantes.DOMICILIATIONS_BANCAIRES.supprimer) }">
                  {{ $t('general.button.delete') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </v-client-table>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpEditionLibelle">
      <pop-up-edition-libelle v-if="openPopUpEditionLibelle"
                              @save="saveEditLibelle"
                              :is-reference="domBancaireReglementEdit.isReference"
                              :value="domBancaireReglementEdit.value"
                              :sens="domBancaireReglementEdit.sens"
                              :type="domBancaireReglementEdit.type">
      </pop-up-edition-libelle>
    </b-modal>
    <b-modal v-model="openPopUpPrevention" width="500px">
      <pop-up-prevention
        :messHeader="indexDomBancaireReglementToDelete.length === 1
        ? $t('addDomiciliationBancaire.domBancaireReglement.popUpPrevention.delete')
        : $t('addDomiciliationBancaire.domBancaireReglement.popUpPrevention.deleteMultiple')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @no="openPopUpPrevention = false"
        @yes="deleteDomBancaireReglement"
      />
    </b-modal>
    <b-modal v-model="openPopUpCreateSpecialisation">
      <pop-up-create-specialisation :domiciliation-bancaire="domiciliationBancaire"
                                    @addSpecialisation="addSpecialisation">
      </pop-up-create-specialisation>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import selecteurAction from '@/components/general/selecteurAction';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { SENS_VENTE } from '@/configuration/devisConf';
import { DOMICILIATIONS_BANCAIRES } from '@/configuration/general/permissionsParametrageConf';
import popUpEditionLibelle from '@/components/parametrage/domiciliationBancaire/addEdit/p_edit';
import messageSuccess from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import popUpCreateSpecialisation from '@/components/parametrage/domiciliationBancaire/addEdit/p_createSpecialisation';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    domiciliationBancaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      domBancaireReglementList: [],
      domBancaireReglementEdit: null,
      openPopUpEditionLibelle: false,
      openPopUpPrevention: false,
      openPopUpCreateSpecialisation: false,
      indexDomBancaireReglementToDelete: [],
      actions: [
        { action: ACTION_DELETE, translation: 'general.button.delete' },
      ],
      constantes: {
        SENS_VENTE,
        DOMICILIATIONS_BANCAIRES,
      },
    };
  },
  components: {
    selecteurAction,
    popUpEditionLibelle,
    popUpPrevention,
    popUpCreateSpecialisation,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    areAllDomBancaireReglementSelected() {
      return this.domBancaireReglementList.length
        && !this.domBancaireReglementList.some(item => !item.selected);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          modeReglement: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.libelleMode'),
          sens: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.sens'),
          libelleEcriture: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.libelleEcriture'),
          libelleLigneEcritureTiers: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.libelleEcritureClient'),
          libelleLigneEcritureBanque: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.libelleEcritureBanque'),
          libelleReferenceTiers: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.referenceTiers'),
          libelleReferenceBanque: this.$t('addDomiciliationBancaire.domBancaireReglement.tab.referenceBanque'),
          actions: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.areAllDomBancaireReglementSelected;
                    this.domBancaireReglementList.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.areAllDomBancaireReglementSelected ? 'checkbox-multiple-marked-outline' : 'checkbox-multiple-blank-outline',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          selected: 'colonneSelected',
          actions: 'colonneSelected',
        },
        sortable: [],
      };
    },
    columns() {
      return ['selected', 'modeReglement', 'sens', 'libelleEcriture', 'libelleLigneEcritureTiers', 'libelleLigneEcritureBanque', 'libelleReferenceTiers', 'libelleReferenceBanque', 'actions'];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    addSpecialisation(specialisation) {
      this.domiciliationBancaire.domBancaireReglement.push(specialisation);
      this.domBancaireReglementList.push(specialisation);
      this.openPopUpCreateSpecialisation = false;
    },
    openPopUpPreventionToDelete(index) {
      this.indexDomBancaireReglementToDelete = [index];
      this.openPopUpPrevention = true;
    },
    deleteDomBancaireReglement() {
      const loadingComponent = this.$buefy.loading.open();
      const domBancaireList = [];
      for (let index = 0; index < this.domBancaireReglementList.length; index += 1) {
        if (this.indexDomBancaireReglementToDelete.find((i) => { return i === index; })
          === undefined) domBancaireList.push(this.domBancaireReglementList[index]);
      }
      this.domBancaireReglementList = cloneDeep(domBancaireList);
      domBancaireList.forEach((dom) => { delete dom.selected; });
      this.domiciliationBancaire.domBancaireReglement = cloneDeep(domBancaireList);
      this.openPopUpPrevention = false;
      messageSuccess(domBancaireList.length === 1
        ? this.$i18n.t('addDomiciliationBancaire.success.deleteDomBancaireReglement')
        : this.$i18n.t('addDomiciliationBancaire.success.deleteMultipleDomBancaireReglement'));
      loadingComponent.close();
    },
    editLibelle(index, sens, type, value, propertieToEdit, isReference) {
      this.domBancaireReglementEdit = {
        type: type,
        value: value,
        sens: sens,
        index: index,
        propertieToEdit: propertieToEdit,
        isReference: isReference,
      };
      this.openPopUpEditionLibelle = true;
    },
    saveEditLibelle(dataToSave) {
      this.domBancaireReglementList[this.domBancaireReglementEdit.index][this
        .domBancaireReglementEdit.propertieToEdit] = dataToSave.value;
      this.domiciliationBancaire.domBancaireReglement[this.domBancaireReglementEdit.index][this
        .domBancaireReglementEdit.propertieToEdit] = dataToSave.value;
      messageSuccess(this.$i18n.t('addDomiciliationBancaire.success.editDomBancaireReglement'));
    },
    getModeReglement(modeReglementId) {
      const modeReglement = this.parametre(PARAMETRES_KEYS.modeReglement).find((mode) => {
        return mode.id === modeReglementId;
      });
      return modeReglement ? modeReglement.libelle : null;
    },
    handleAction(action) {
      if (action === ACTION_DELETE) {
        for (let index = 0; index < this.domBancaireReglementList.length; index += 1) {
          if (this.domBancaireReglementList[index].selected) {
            this.indexDomBancaireReglementToDelete.push(index);
          }
        }
        this.openPopUpPrevention = true;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const domBancaireReglementList = cloneDeep(this.domiciliationBancaire.domBancaireReglement);
      domBancaireReglementList.forEach((dom) => {
        dom.selected = false;
      });
      this.domBancaireReglementList = domBancaireReglementList;
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
